import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleStack24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSpeechBubbleStack24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.163 14.77v-1.5H5a1.5 1.5 0 0 1-1.5-1.5V7A1.5 1.5 0 0 1 5 5.5h9.385a1.5 1.5 0 0 1 1.5 1.5v4.77a1.5 1.5 0 0 1-1.5 1.5H9.817l-.436.422-2.218 2.15zm7.222 0h-3.96l-2.218 2.149c-.952.922-2.544.248-2.544-1.077v-1.073H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h9.385a3 3 0 0 1 3 3v4.77a3 3 0 0 1-3 3m-.81 3.845H8.923l1.5-1.5h3.76l.436.423 2.218 2.15v-2.573H19a1.5 1.5 0 0 0 1.5-1.5v-4.769a1.5 1.5 0 0 0-1.5-1.5h-.077v-1.5H19a3 3 0 0 1 3 3v4.77a3 3 0 0 1-3 3h-.663v1.072c0 1.325-1.592 2-2.544 1.077z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleStack24);
